import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthProvider } from 'src/app/providers';
import { Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { ToasterService, CommonService } from 'src/app/services';

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit {

  recoveryForm: UntypedFormGroup;
  isCodeValid = false;
  code: string;
  user: User;
  resetDone: boolean = false;
  error: string = '';

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private authProvider: AuthProvider,
    private router: Router,
    private toastr: ToasterService,
    public commonService: CommonService
  ) {
    this.recoveryForm = this.fb.group({
      USER_PASSWORD: [null, Validators.compose([Validators.required, Validators.pattern('^(?=.*[A-Za-z])(?=.*\\d)(?=.*[$@$!%*#?&])[A-Za-z\\d$@$!%*#?&]{8,}$')])],
      USER_CONFIRM_PASSWORD: [null, Validators.compose([Validators.required, this.compareValidator('USER_PASSWORD')])]
    });
  }

  ngOnInit(): void {
    this.code = this.route.snapshot.queryParams.code;

    if (!this.code) {
      this.isCodeValid = false;
    } else {
      this.isCodeValid = true;
    }

    // Check code is valid or not
    this.authProvider.getRecoveryByCode(this.code).subscribe(response => {
      if (response.success) {
        this.isCodeValid = true;
        this.user = response.result;
      } else {
        /** If code is invalid Route user to login(default) page */
        this.isCodeValid = false;
      }
    }, err => {
      this.isCodeValid = false;
      console.error(err);
    });
  }

  /** 
   * @description Back to login page
   */
  backToLogin() {
    this.router.navigate(['/login']);
  }

  /**
   * Compare password and confirm password if match
   * @param controlNameToCompare - The control name to compare
   */
  compareValidator(controlNameToCompare: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (c.value === null || c.value.length === 0) {
        return null;
      }

      const controlToCompare = c.root.get(controlNameToCompare);
      if (controlToCompare) {
        const subscription: Subscription = controlToCompare.valueChanges.subscribe(() => {
          c.updateValueAndValidity();
          subscription.unsubscribe();
        });
      }

      return controlToCompare && controlToCompare.value !== c.value ? { compare: true } : null;
    };
  }

  /**
   * @description When clicked, process password recovery
   */
  onSubmit(): void {
    if (this.recoveryForm.valid) {
      const params = {
        password: this.recoveryForm.value.USER_PASSWORD
      }
      this.error = '';
      this.authProvider.completeReset(params, this.code).subscribe(response => {
        if (response.success) {
          this.resetDone = true;
          this.recoveryForm.reset();
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 6000);
        } else {
          this.error = response.error.txt;
        }
      }, err => {
        console.error(err);
      });
    } else {
      this.recoveryForm.markAllAsTouched();
    }
  }

  /**
   * @description validation of control
   */
  checkControlValid(controlName: string) {
    const controlDetails = this.recoveryForm.get(controlName);
    if (!controlDetails) {
      return false;
    }
    return (controlDetails.touched || controlDetails.dirty) && controlDetails.invalid;
  }

}
